import { useLargeScreenMediaQuery } from "@/react/hooks/useMediaQuery";
import { Drawer } from "@circle-react-shared/uikit/Drawer";
import { Content } from "./Content";
import { Header } from "./Header";

interface FilesProps {
  onHeaderCloseClick: () => void;
}

export const Files = ({ onHeaderCloseClick }: FilesProps) => {
  const isMobile = useLargeScreenMediaQuery();

  if (isMobile) {
    return (
      <Drawer className="!z-[1061]" open hideHeader noWrapperPadding>
        <Header onHeaderCloseClick={onHeaderCloseClick} />
        <Content />
      </Drawer>
    );
  }
  return (
    <div className="border-primary grid-in-right-sidebar hidden max-w-[360px] flex-col border-l transition-all duration-200 lg:flex">
      <Header onHeaderCloseClick={onHeaderCloseClick} />
      <Content />
    </div>
  );
};
